import { Auth0Client } from '@auth0/auth0-spa-js';

export let auth0Client: Auth0Client | null = null;

export const setAuth0Client = (client: Auth0Client) => {
    auth0Client = client;
};
